// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"7112f8fe","787":"742d683c","802":"aedafff9"}[chunkId] + ".chunk.js";
};